module.exports = __webpack_public_path__ + "static/media/nilai-kerja.6069a6a7.svg";